// ** MUI Imports
import { Theme } from '@mui/material/styles'

const Autocomplete = (theme: Theme) => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[6]
        }
      }
    }
  }
}

export default Autocomplete
